import React from "react";
import ScrollContainer from "react-indiana-drag-scroll";

const PillButton = ({ title }) => {
  return (
    <button
      className={`w-fit cursor-pointer text-nowrap rounded-full bg-[#FAD8DA] px-3 py-2 text-sm font-medium text-black`}
    >
      {title}
    </button>
  );
};

const ContentSection = ({ category, subtitle, pills }) => {
  return (
    <div className="shadow-socialglass flex h-auto flex-col rounded-lg px-2 py-3">
      <div className="flex items-center gap-2">
        <span className="text-2xl">📅</span>
        <h2 className="text-xl font-semibold text-gray-800">{category}</h2>
      </div>

      {subtitle && (
        <p className="text-left text-sm italic text-gray-500">{subtitle}</p>
      )}

      <ScrollContainer className="hide-scrollbar flex h-full items-start gap-x-8 overflow-x-auto overflow-y-hidden active:cursor-grabbing">
        {pills.map((pill, index) => (
          <PillButton key={index} title={pill} />
        ))}
      </ScrollContainer>
    </div>
  );
};

export default ContentSection;
